import React from 'react'
import { Link } from 'react-router-dom';

function TopBanner(props) {
  
  const usrName = localStorage.getItem('userName');

  const { name } = props;

  const servername = localStorage.getItem('server');
  

  return (
    <div className='cont__TopBanner'>
      <div className="c12-l-5 justify-content-center">
        <h4 className="wide txt-darkblue">{name}</h4>
      </div>
      <div className="c12-l-1 align-items-end justify-content-center">
        <p className="small"  style={{'fontSize':'8px'}}>{servername}</p>
      </div>
      <div className="c12-l-3 align-items-end justify-content-center">
        <p className="small" >Welcome {usrName}</p>
      </div>
      <div className="c12-l-3 align-items-end justify-content-center ">
        <div className="flex">
          
          <Link to="/Modal" className="btn changepwd">
            Change Password 
          </Link>
          
{/*
          <button className="btn changepwd" style = {{"width":"150px", "height":"23px"}}onClick={handleClick}>Change Password</button>
*/}
          <Link to="/Closeapp" className="btn logout">
            Logout
          </Link>

        </div>
      </div>
    </div>
  )
}

export default TopBanner
